/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScanSessionResultModel } from '../../models/scan-session-result-model';
import { SdkCompletedModel } from '../../models/sdk-completed-model';

export interface ScanSdkCompletedPost$Params {
      body?: SdkCompletedModel
}

export function scanSdkCompletedPost(http: HttpClient, rootUrl: string, params?: ScanSdkCompletedPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<ScanSessionResultModel>> {
  const rb = new RequestBuilder(rootUrl, scanSdkCompletedPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<ScanSessionResultModel>;
    })
  );
}

scanSdkCompletedPost.PATH = '/Scan/SDKCompleted';
